<div class="container-header">
    <div class="section-header">
        <div class="header-logo">
            <img src="assets/logo/logo-ironside.png" alt="" />
            <h3>MODULE D'IMPORT DES TRAMES</h3>
        </div>

        <div class="header-actions">
            <button class="btn-action" (click)="goToHome()">RETOUR À L’ACCUEIL</button>
        </div>
    </div>
    <div class="section-tag">
        <span>Import des trames</span>
    </div>
</div>
